import {
  ACTION_LOAD_ACTIVE_SITES__REQUEST,
  ACTION_LOAD_ACTIVE_SITES__SUCCESS,
  ACTION_LOAD_ACTIVE_SITES__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_ACTIVE_SITES__REQUEST:
    case ACTION_LOAD_ACTIVE_SITES__SUCCESS:
      return null;

    case ACTION_LOAD_ACTIVE_SITES__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
